import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function Subscribers() {
  const [subs, setSubs] = useState([]);
  useEffect(() => { api.get("/admin/subscribers").then((r) => setSubs(r.data)); }, []);
  const download = () => {
    const csv = "email,source,created_at\n" + subs.map((s) => `${s.email},${s.source||""},${s.created_at||""}`).join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = "golden-moth-subscribers.csv"; a.click();
    URL.revokeObjectURL(url);
  };
  return (
    <div>
      <div className="flex flex-wrap gap-3 items-center mb-6">
        <h1 className="font-display text-2xl sm:text-3xl text-gold flex-1">Subscribers ({subs.length})</h1>
        <button onClick={download} data-testid="subs-download" className="btn-outline text-xs">Export CSV</button>
      </div>
      <div className="curio-card divide-y divide-brass-soft/40">
        {subs.length === 0 && <div className="p-8 text-center text-parchment/60 italic">No subscribers yet.</div>}
        {subs.map((s) => (
          <div key={s.id} className="flex items-center justify-between p-4 gap-4" data-testid={`sub-row-${s.email}`}>
            <div>
              <div className="text-cream text-sm">{s.email}</div>
              <div className="font-caption text-[10px] text-brass/70 mt-1">from {s.source || "unknown"} · {new Date(s.created_at).toLocaleDateString()}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
